<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="手机号:">
              <el-input v-model.trim="formInlineTmp.mobile" placeholder="请输入手机号查询" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">子账户列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right" style="">

      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="所属经销商">
          <template slot-scope="scope">
            {{ scope.row.dealer_name }}
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            {{ scope.row.role.title }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div class="op-link" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getYxDealerSub, deleteYxDealer } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      id: 0,
      loading: true,
      formInlineTmp:{},
      formInline: {
        title:'',
      },
      options: [],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxDealerSub(this.id, this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    pushToSubPage(id) {
      router.push({ name: 'editActivitys', query: { id: id } })
    },
    // 删除
    deleteAction(id) {
      this.$confirm('确认删除次账户信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteYxDealer(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>

</style>
